<template>
  <div>
    <b-navbar
      class="d-flex"
      :class="{shadow: scroll}"
      id="navbarText"
      style="background-color: var(--third) !important;"
    >
      <!-- Logo y nombre "Cube Consolidation" a la izquierda -->
      <b-navbar-brand href="/home" class="logo-container">
        <div class="brand-wrapper">
          <img
            :src="cubeLogoSrc"
            alt="Cube Logo"
            class="brand-icon"
          />
          <span class="brand-text">
            Cube <span class="brand-highlight">Consolidation</span>
          </span>
        </div>
      </b-navbar-brand>

      <!-- Espacio flexible para centrar contenido opcional -->
      <div class="flex-grow-1"></div>

      <!-- Saludo + manito, FUERA del dropdown, a la izquierda del botón de usuario -->
      <div v-if="isAuthenticated" class="greeting-wrapper">
        <span class="greeting-text">
          <span v-if="language == 'es-ES'">Hola</span>
          <span v-else>Hello</span>
        </span>
        <span class="waving-hand" role="img" aria-label="saludo">👋</span>
      </div>

      <!-- Dropdown de usuario a la derecha -->
      <b-dropdown
        v-if="isAuthenticated"
        end
        variant="link"
        toggle-class="user-dropdown-toggle"
        menu-class="user-dropdown-menu"
        class="ml-auto"
        no-caret
        @show="syncMenuWidth"
      >
        <template #button-content>
          <div class="user-button" ref="userButton">
            <span class="user-name">{{ currentUserName }}</span>
            <svg class="chevron-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </template>
        
        <div class="dropdown-content">
          <!-- Email del usuario -->
          <div class="user-email">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 2L7 7L13 2M1 12H13V2H1V12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>{{ userEmail }}</span>
          </div>
          
          <!-- Separador -->
          <div class="dropdown-divider"></div>
          
          <!-- Logout -->
          <button type="button" class="logout-button" @click="logout()">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 14H3C2.46957 14 1.96086 13.7893 1.58579 13.4142C1.21071 13.0391 1 12.5304 1 12V4C1 3.46957 1.21071 2.96086 1.58579 2.58579C1.96086 2.21071 2.46957 2 3 2H6M11 11L15 7L11 3M15 7H6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span v-if="language == 'es-ES'">Cerrar sesión</span>
            <span v-else>Logout</span>
          </button>
        </div>
      </b-dropdown>
    </b-navbar>
  </div>
</template>

<script>
import Authentication from "@/services/Authentication"
import User from "@/services/User"

// Ruta correcta para las imágenes desde partials
const imageContext = require.context("../../assets/imgs", false, /\.(png|jpe?g|svg)$/i);

export default {
  name: "AppHeader",
  data() {
    return {
      icono: "",
      compania: "",
      menu: "",
      home: "/#home",
      scroll: false,
      currentUserDisplayName: "",
      currentUserEmail: ""
    };
  },
  beforeMount() {
    window.addEventListener("scroll", this.scrollFunction);
    if(this.$store.state.isAuthenticated){
      const now = new Date();
      const expiresIn = (new Date(this.$store.state.expiration)).getTime() - now.getTime();
      setTimeout(() => {
        console.log("YAY")
        this.logout()
      }, expiresIn);
    }
  },
  methods: {
    scrollFunction(e) {
      this.scroll = window.pageYOffset > 300
      e.preventDefault()
    },
    logout: function() {
      const obj = {
        token: "",
        username: "",
        role: "",
        expiresIn: "",
        isAuthenticated: false,
      };
      this.$store.commit("setData", obj);
      this.$router.push("/");
    },
    toggleLanguage() {
      if (this.$store.state._language == "es-ES") {
        this.$store.commit("setLang", "en-US");
      } else {
        this.$store.commit("setLang", "es-ES");
      }
    },
    loadCurrentUserName() {
      const userId = this.$store.state.userId;

      if (!this.$store.state.isAuthenticated || !userId) return;

      // Si ya tenemos el nombre en Vuex, lo usamos
      if (this.$store.state.userName) {
        this.currentUserDisplayName = this.$store.state.userName;
      }

      // Pero igualmente consultamos el usuario para obtener el email
      User.getAllUsersById(userId)
        .then((res) => {
          console.log("Respuesta usuario:", res);

          const userData = res?.data?.exiteUser?.[0];

          if (userData) {
            this.currentUserDisplayName =
              userData.nombre || userData.name || this.currentUserDisplayName;

            this.currentUserEmail = userData.email || "";
          }
        })
        .catch((error) => {
          console.error("Error obteniendo usuario:", error);
        });
    },
    syncMenuWidth() {
      this.$nextTick(() => {
        const button = this.$refs.userButton;
        if (!button) return;
        const width = button.getBoundingClientRect().width;
        const menu = document.querySelector('.user-dropdown-menu');
        if (menu) {
          menu.style.minWidth = `${width}px`;
          menu.style.width = 'max-content';
        }
      });
    },
  },
  computed: {
    logoSrc() {
      const fallback = imageContext("./logo-login.png");
      if (!this.icono) {
        return fallback;
      }

      const candidates = [this.icono, `${this.icono}.png`, `${this.icono}.jpg`, `${this.icono}.jpeg`];
      for (const file of candidates) {
        try {
          return imageContext(`./${file}`);
        } catch (e) {
          // Continue trying other extensions/names.
        }
      }
      return fallback;
    },
    cubeLogoSrc() {
      // Logo de Cube Consolidation - ruta correcta desde partials
      try {
        return require("@/assets/LogoComplementCubeWhite2.png");
      } catch (e) {
        // Fallback: intentar con otra ruta
        try {
          return require("../../assets/LogoComplementCubeWhite2.png");
        } catch (err) {
          return require("../../assets/imgs/logo-login.png");
        }
      }
    },
    role() {
      return this.$store.state.userRole;
    },
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
    language() {
      return this.$store.state._language;
    },
    currentUserName() {
      return this.$store.state.userName || this.currentUserDisplayName || "";
    },
    userEmail() {
      return this.$store.state.userEmail || this.currentUserEmail || "";
    }
  },
  mounted() {
    Authentication.leaParametros()
      .then ((result) => {
        this.icono = result.data.parametros.icono
        this.compania = result.data.parametros.compania
      })
    this.loadCurrentUserName()
  }
}
</script>

<style scoped>
/* Reset de estilos del dropdown - TODOS los estados */
.user-dropdown-toggle,
.user-dropdown-toggle:hover,
.user-dropdown-toggle:focus,
.user-dropdown-toggle:active,
.user-dropdown-toggle:focus-visible,
.user-dropdown-toggle.show {
  padding: 0 !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

.user-dropdown-toggle::after {
  display: none !important;
}

/* Por si el <button> interno no hereda el scope, forzamos con :deep() */
:deep(.user-dropdown-toggle),
:deep(.user-dropdown-toggle:hover),
:deep(.user-dropdown-toggle:focus),
:deep(.user-dropdown-toggle:active),
:deep(.user-dropdown-toggle:focus-visible),
:deep(.user-dropdown-toggle.show) {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

/* El wrapper que genera b-dropdown también puede traer estilos de Bootstrap */
:deep(.dropdown) {
  border: none !important;
}

/* Menú desplegable - compacto y alineado a la derecha */
.user-dropdown-menu {
  min-width: unset !important;
  width: max-content !important;
  max-width: 280px !important;
  padding: 6px !important;
  border: none !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08), 0 1px 4px rgba(0, 0, 0, 0.04) !important;
  background: white !important;
  margin-top: 8px !important;
  left: auto !important;
  right: 0 !important;
  transform: none !important;
  box-sizing: border-box !important;
}

/* Asegurar que el contenedor del dropdown permita el posicionamiento */
:deep(.dropdown) {
  position: relative !important;
}

:deep(.dropdown-menu) {
  left: auto !important;
  right: 0 !important;
}

.dropdown-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

/* Logo y marca */
.logo-container {
  display: flex;
  align-items: center;
  text-decoration: none !important;
  padding: 0 !important;
  flex-shrink: 0;
}

.brand-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-icon {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.brand-text {
  font-weight: 700;
  font-size: 18px;
  color: #016690;
  white-space: nowrap;
}

.brand-highlight {
  color: #ffb171;
}

/* ===== Saludo (fuera del dropdown) ===== */
.greeting-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-right: 12px;
  flex-shrink: 0;
}

.greeting-text {
  color: #6c757d;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

.waving-hand {
  font-size: 20px;
  line-height: 1;
  display: inline-block;
  transform-origin: 70% 70%;
  animation: wave-animation 2.5s ease-in-out 1;
  flex-shrink: 0;
}

@keyframes wave-animation {
  0% { transform: rotate(0deg); }
  10% { transform: rotate(14deg); }
  20% { transform: rotate(-8deg); }
  30% { transform: rotate(14deg); }
  40% { transform: rotate(-4deg); }
  50% { transform: rotate(10deg); }
  60% { transform: rotate(0deg); }
  100% { transform: rotate(0deg); }
}

/* Botón de usuario */
.user-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
  cursor: pointer;
  font-size: 14px;
  color: #212529;
  white-space: nowrap;
}

.user-button:hover {
  background: #f1f3f5;
  border-color: #dee2e6;
}

.user-name {
  font-weight: 500;
  color: #212529;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chevron-icon {
  color: #868e96;
  transition: transform 0.2s ease;
  flex-shrink: 0;
}

/* Rotar ícono cuando está abierto */
.show .chevron-icon {
  transform: rotate(180deg);
}

/* Email del usuario */
.user-email {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  color: #6c757d;
  font-size: 13px;
  font-weight: 400;
  white-space: nowrap;
}

.user-email svg {
  color: #adb5bd;
  flex-shrink: 0;
}

.user-email span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Separador */
.dropdown-divider {
  height: 1px;
  background: #e9ecef;
  margin: 4px 6px;
}

/* Botón de logout */
.logout-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: #dc3545;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  width: 100%;
  text-align: left;
  white-space: nowrap;
}

.logout-button:hover {
  background: #fff5f5;
  color: #c82333;
}

.logout-button:active {
  transform: scale(0.98);
}

.logout-button svg {
  flex-shrink: 0;
}

/* ===== ESTILOS DEL NAVBAR ===== */
#navbarText {
  padding-left: 0 !important;
  padding-right: 0 !important;
  background-color: var(--third) !important;
  min-height: 60px;
}

/* ===== RESPONSIVE: REDUCIR PADDING ===== */
@media (max-width: 768px) {
  #navbarText {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .user-button {
    padding: 6px 12px;
    font-size: 13px;
  }
  
  .user-name {
    max-width: 80px;
  }
  
  .user-dropdown-menu {
    min-width: unset !important;
    width: max-content !important;
    max-width: 240px !important;
    left: auto !important;
    right: 0 !important;
  }

  .brand-text {
    font-size: 15px;
  }

  .brand-icon {
    width: 26px;
    height: 26px;
  }

  .greeting-text {
    font-size: 13px;
  }

  .waving-hand {
    font-size: 18px;
  }
}

@media (max-width: 480px) {
  #navbarText {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
  
  .brand-text {
    font-size: 13px;
  }
  
  .brand-icon {
    width: 22px;
    height: 22px;
  }
  
  .user-button {
    padding: 4px 10px;
    font-size: 12px;
  }
  
  .user-name {
    max-width: 60px;
  }

  .greeting-wrapper {
    margin-right: 6px;
  }

  .greeting-text {
    font-size: 12px;
  }

  .waving-hand {
    font-size: 16px;
  }
}
</style>